/**
 * Product in the field section — watch-video dialog.
 * Carousel prev/next use slideshow-arrow on:click inside slideshow-component.
 */

/**
 * @param {HTMLElement} section
 */
function bindWatchDialog(section) {
  const dialogEl = section.querySelector('dialog[data-field-video-dialog]');
  const player = section.querySelector('[data-field-video-player]');
  if (!(dialogEl instanceof HTMLDialogElement) || !player) return;

  /** @param {HTMLElement} trigger */
  const openFromTrigger = (trigger) => {
    const media = trigger.closest('.product-in-the-field__media--video');
    if (!(media instanceof HTMLElement)) return;

    player.replaceChildren();
    const videoId = media.dataset.videoId;
    const videoType = media.dataset.videoType || 'youtube';
    const fileSrc = media.dataset.videoFile;

    if (videoId) {
      const iframe = document.createElement('iframe');
      iframe.className = 'product-in-the-field__dialog-iframe';
      iframe.title = 'Video';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.src =
        videoType === 'vimeo'
          ? `https://player.vimeo.com/video/${videoId}?autoplay=1&mute=0&playsinline=1`
          : `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&playsinline=1&rel=0`;
      player.appendChild(iframe);
    } else if (fileSrc) {
      const video = document.createElement('video');
      video.className = 'product-in-the-field__dialog-video';
      video.controls = true;
      video.playsInline = true;
      video.autoplay = true;
      video.src = fileSrc;
      player.appendChild(video);
    } else {
      return;
    }

    if (typeof dialogEl.showModal === 'function') {
      dialogEl.showModal();
    }
  };

  section.querySelectorAll('[data-field-watch-trigger]').forEach((trigger) => {
    if (!(trigger instanceof HTMLElement)) return;
    trigger.addEventListener('click', () => openFromTrigger(trigger));
  });

  dialogEl.addEventListener('close', () => {
    player.replaceChildren();
  });

  section.querySelector('[data-field-video-dialog-close]')?.addEventListener('click', () => {
    dialogEl.close();
  });

  dialogEl.addEventListener('click', (event) => {
    if (event.target === dialogEl) {
      dialogEl.close();
    }
  });
}

/**
 * @param {HTMLElement} section
 */
function initProductInTheField(section) {
  if (section.dataset.fieldInit === 'true') return;
  section.dataset.fieldInit = 'true';
  bindWatchDialog(section);
}

/** @param {ParentNode} [scope] */
function initScope(scope = document) {
  scope.querySelectorAll?.('product-in-the-field').forEach((el) => {
    if (el instanceof HTMLElement) initProductInTheField(el);
  });
}

initScope();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) initScope(event.target);
});

document.addEventListener('shopify:section:reorder', (event) => {
  if (event.target instanceof HTMLElement) initScope(event.target);
});
